import script from "./SortingButtonDropDown.vue?vue&type=script&setup=true&lang=ts"
export * from "./SortingButtonDropDown.vue?vue&type=script&setup=true&lang=ts"

import "./SortingButtonDropDown.vue?vue&type=style&index=0&id=6c1cfb39&lang=css"

const __exports__ = script;

export default __exports__